import {NgModule} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import {SharedModule} from '../../../core/shared.module';
import {ArticleBoxComponent} from './article-box.component';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {ArticleButtonBoxComponent} from './article-button-box.component';
import {LoadingOrErrorModule} from '../../../common/loading/loading-or-error.module';
import {ArticleModule} from '../article.module';
import {ArticleWizardButtonModule} from '../article-wizard-button/article-wizard-button.module';

@NgModule({
  imports: [
    SharedModule,
    NgbTooltipModule,
    LoadingOrErrorModule,
    UIRouterModule.forChild(),
    ArticleModule,
    ArticleWizardButtonModule,
  ],
    declarations: [
        ArticleBoxComponent,
        ArticleButtonBoxComponent
    ],
    exports: [
        ArticleBoxComponent,
        ArticleButtonBoxComponent
    ]
})
export class ArticleBoxModule {
}
